export const isObjectEmpty = (list): boolean => Object.values(list).every(item => !!item);
